import { makeAutoObservable } from "mobx"
import React from "react"

import { AsyncRequestService } from "src/api"
import { adminv3_AsyncRequestResponse } from "src/api/models/adminv3_AsyncRequestResponse"
import { createLoadingKeys } from "src/lib/loading"
import { reportUnhandledApiError } from "src/lib/report"

export class AsyncRequestDetailModalStore {
    static Context = React.createContext<AsyncRequestDetailModalStore | null>(
        null,
    )
    static LoadingKeys = createLoadingKeys("init")

    asyncRequest: adminv3_AsyncRequestResponse | null = null

    constructor() {
        makeAutoObservable(this)
    }

    async init(id: number) {
        try {
            this.asyncRequest =
                await AsyncRequestService.getV3AdminAsyncRequest({ id })
        } catch (error) {
            reportUnhandledApiError(error)
        }
    }

    get isLoading() {
        return this.asyncRequest === null
    }
}
